import { render, staticRenderFns } from "./WardMessage.vue?vue&type=template&id=2e77209b&scoped=true&"
import script from "./WardMessage.vue?vue&type=script&lang=js&"
export * from "./WardMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e77209b",
  null
  
)

export default component.exports